import type { FC, PropsWithChildren } from 'react'
import { useDraggableCue } from '../lib/use-draggable-cue'
import { useAtomValue } from 'jotai'
import { draggingCueAtom } from '../store/dnd.store'
import { cn } from '@/utils'
import { getIndexedCueAtom } from '../../../store/rundown.store'

type SortableCueProps = {
  cueId: string
}

export const SortableCue: FC<PropsWithChildren<SortableCueProps>> = ({
  cueId,
  children,
}) => {
  const draggingCue = useAtomValue(draggingCueAtom)
  const getCueMeta = useAtomValue(getIndexedCueAtom)
  const cue = getCueMeta(cueId)

  const {
    draggable: { attributes, setNodeRef },
    style,
  } = useDraggableCue(cue)

  return (
    <div
      {...attributes}
      ref={setNodeRef}
      style={style}
      className={cn(
        // We're using custom `DragOverlay`, so visually remove actual element while dragging
        draggingCue?.id === cue.id && 'opacity-0',
      )}
      // Override all properties that affect ARIA structure.
      // The row is draggable, but we want a11y engines to ignore it and look at the child element instead.
      role="none"
      tabIndex={undefined}
      aria-disabled={undefined}
      aria-roledescription={undefined}
      aria-describedby={undefined}
    >
      {children}
    </div>
  )
}
